import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  height: 128px;
  width: 100%;
`;
